export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_13.ef99c9c7.jpg";